// Styles for ConsentCheckListItem go here.
import { toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledConsentCheckListItem = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
  margin: ${toRem(8)} 0;
  .m-checkbox-error {
    .legal-text-link {
      margin: ${toRem(8)} 0 0;
      color: red;
    }
  }
`;
